import React from 'react';
import './EnvBannerStyles.css';

const EnvironmentBanner = () => {
  const environment = process.env.REACT_APP_ENV || 'unknown';

  if (environment === 'production') return null; // Don't show banner in production

  return (
    <div className={`env-banner env-${environment}`}>
      <span>{environment.toUpperCase()}</span>
    </div>
  );
};

export default EnvironmentBanner;
